module.exports = __webpack_public_path__ + "static/media/CDAC-logo.902e4fda.webp";